import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastService } from '../../../../../services/toast.service';
import { ContratoTMA } from '../../../../../types/ContratoTMA.type';
import { Empresa } from '../../../../../types/Empresa.type';
import {ContratoService} from "../../../../../services/contrato.service";
import {IntegradorService} from "../../../../../services/integrador.service";

@Component({
  selector: 'app-tmadialog',
  templateUrl: './tmadialog.component.html',
  styleUrl: './tmadialog.component.css'
})
export class TmadialogComponent {

  @Input() visivel: boolean = false;
  @Input() taxa: ContratoTMA = {} as ContratoTMA;
  @Output() public fechar = new EventEmitter();

  empresas: Empresa[] = [];


  taxaCadastro: ContratoTMA = {} as ContratoTMA;

  constructor(private contratoService: ContratoService, private toastService: ToastService, private integradorService: IntegradorService) {
    this.buscaEmpresas();
  }

  fecharDialog() {
      this.visivel = false;
      this.taxa = {} as ContratoTMA;
      this.taxaCadastro = {} as ContratoTMA;
      this.fechar.emit();
    }

  buscaEmpresas(){
      this.integradorService.getEmpresas().subscribe({
        next: (data) => {
          this.empresas = data
        },
        error: (error) => {
          console.error(error)
          this.toastService.erro("Erro", error.error.message)
        }
      })
    }

    salvar() {
      Object.assign(this.taxaCadastro, this.taxa);

      let empresaSelecionada = this.buscaEmpresaSelecionada(this.taxaCadastro.deEmpresa);

      if(empresaSelecionada != undefined){
        this.taxaCadastro.idEmpresa = empresaSelecionada.id;
      }

      this.taxaCadastro.deEmpresa = this.taxaCadastro.deEmpresa?.trim() != '' ? this.taxaCadastro.deEmpresa : '';
      this.taxaCadastro.dataInicial = this.taxaCadastro.dataInicial?.trim() != '' ? this.taxaCadastro.dataInicial : null;
      this.taxaCadastro.dataFinal = this.taxaCadastro.dataFinal?.trim() != '' ? this.taxaCadastro.dataFinal : null;

      if (this.taxa.id) {

        this.contratoService.putTma(this.taxaCadastro).subscribe({
          next: () => {
            this.toastService.sucesso('Sucesso', 'Taxa atualizada com sucesso');
            this.fecharDialog();
          },
          error: (value) => {
            this.toastService.erro('Erro', 'Erro ao salvar: ' + value.error.message);
          },
        });
      } else {

        this.contratoService.postTma(this.taxaCadastro).subscribe({
          next: (valor) => {
            Object.assign(this.taxa, valor);
            this.toastService.sucesso('Sucesso', 'Taxa salva com sucesso');
            this.fecharDialog();
          },
          error: (value) => {
            this.toastService.erro('Erro', 'Erro ao salvar: ' + value.error.message);
          },
        });
      }
    }

    buscaEmpresaSelecionada = (empresaErp: string): Empresa | undefined => {
      return this.empresas.find(empresa => empresa.empresaErp === empresaErp);
    };

}
